import styled from 'styled-components';

export const Handle = styled.div`
  position: absolute;
  top: -3px;
  left: 50%;
  font-size: 20px;
  color: #999;
  transform: translateX(-50%);
  padding: 0;
  margin: 0;
  line-height: 0;
  cursor: pointer;
  opacity: 0;
  z-index: 9;
  padding: 0px 8px;
  border-radius: 0px 0px 6px 6px;
  background-color: #ececec;
  svg path {
    fill: #999;
  }
  &:hover {
    opacity: 1;
    svg path {
      fill: black;
    }
  }
`;
